<!-- src/components/PopularAddMe.vue -->

<template>
    <Dialog v-model:visible="visible" modal :header="$t('popular_messages.title')" :style="{ width: '25rem' }"
        :closeOnEscape="false">
        <div class="flex items-center mb-4">
            <AvatarGroup class="m-auto">
                <Avatar v-for="popular_user in popular_users.slice(0, 5)" :key="popular_user.user_id"
                    :image="$utils.getAvatar(popular_user.avatar)" shape="circle" />
                <Avatar label="+15" shape="circle" />
            </AvatarGroup>
        </div>

        <div class="flex items-center gap-2 mb-4">
            <span class="font-bold text-lg text-centered">
                {{ $t('popular_messages.promotePhoto', { names: formattedNames }) }}
            </span>
        </div>

        <!-- Servis Ücreti -->
        <div class="flex justify-content-center gap-2 mb-4" v-html="serviceCost">
        </div>

        <!-- Gösterim Süresi -->
        <div class="flex justify-content-center gap-2 mb-4" v-if="is_popular">
            <span>{{ $t('popular_messages.exposureTime', { time: formattedTime }) }}</span>
        </div>

        <div class="flex justify-content-end gap-2">
            <Button type="button" :label="$t('popular_messages.addMe')" severity="success" @click="addMe()"></Button>
        </div>
    </Dialog>
</template>

<script>

export default {
    name: 'PopularAddMe',
    props: ['popular_users', 'my_id', 'g_settings'],
    data() {
        return {
            visible: false,
            is_popular: false,
            time: 0
        }
    },
    computed: {
        // Gösterim Süresini Formatlama
        formattedTime() {
            if (!this.time) return '';
            const expiresDate = new Date(this.time);
            const formattedDate = expiresDate.toLocaleString(this.$i18n.locale, {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });
            return formattedDate;
        },
        // Servis Ücreti Çevirisi
        serviceCost() {
            return this.$t('popular_messages.serviceCost', {
                cost: this.g_settings.popular,
                time: this.g_settings.popular_time
            });
        },
        // Kullanıcı İsimlerini Formatlama
        formattedNames() {
            if (!this.popular_users || this.popular_users.length === 0) {
                return '';
            }
            const filteredUsers = this.popular_users.filter(user => user.gender === 2);
            const limitedUsers = filteredUsers.slice(0, 3);
            const nicknames = limitedUsers.map(user => user.nickname);
            const lastIndex = nicknames.length - 1;

            if (nicknames.length === 1) {
                return nicknames[0];
            } else {
                const allButLast = nicknames.slice(0, lastIndex).join(this.$i18n.locale === 'tr' ? ', ' : ', ');
                const lastName = nicknames[lastIndex];
                return this.$i18n.locale === 'tr' ? `${allButLast} ve ${lastName}` : `${allButLast} and ${lastName}`;
            }
        }
    },
    methods: {
        show() {
            this.visible = true;
        },
        hide() {
            this.visible = false;
        },
        addMe() {
            this.$socket.emit('add-me-popular');
            this.visible = false;
        },
    },
    mounted() {
        const found = this.popular_users.find(user => user.id == this.my_id);
        if (found) {
            this.is_popular = true;
            this.time = found.is_popular;
        }
    },
    watch: {
        popular_users() {
            const found = this.popular_users.find(user => user.id == this.my_id);
            if (found) {
                this.is_popular = true;
                this.time = found.is_popular;
            }
        }
    }
};
</script>

<style scoped>
.text-centered {
    text-align: center;
}
</style>
